import React from 'react'
import ExperienceDetails from '../container/ExperienceDetails'
import Work from '../container/Work'

const Experience = () => {
  return (
    <div>
        <ExperienceDetails/>
        <Work/>
        </div>
  )
}

export default Experience